var map = {
	"./de_DE.json": 1215,
	"./en_AU.json": 1216,
	"./en_CA.json": 1217,
	"./en_GB.json": 1218,
	"./es_AR.json": 1219,
	"./es_ES.json": 1220,
	"./es_MX.json": 1221,
	"./fr_CA.json": 1222,
	"./fr_FR.json": 1223,
	"./it_IT.json": 1224,
	"./nl_NL.json": 1225,
	"./pt_BR.json": 1226,
	"./pt_PT.json": 1227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1214;